import React from 'react';
import BoostedComponent from './BoostedComponent'
import ReservationInformations from './ReservationInformations'
import DateInput from './DateInput'
import moment from 'moment-with-locales-es6';


class ReservationMultiplesDispo extends BoostedComponent {
    constructor(props) {
        super(props)
        this.state = {
            view: 0,
            dispos: [],
            duree: '',
            heureFin: '',
            heureDebut: '',
            debut: '',
            fin: '',
            filtre: 'all'
        }
        this.parent = this.props.parent
        this.constants = this.props.constants
        this.semaines = [];
        for (let i=0; i < 24;i++) {
            this.semaines.push(i+":00",i+":30")
        }

        this.time = [];
        for (let i=1; i < 12;i++) {
            this.time.push(i+":00",i+":30")
        }
        this.time.push(12+":00")

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.heureDebut && this.state.heureFin && this.state.duree && this.state.activites) {
            if (window.jQuery(window).width() < 768 && window.location.hash=="#multiple0") {
                window.jQuery("html,body").animate({scrollTop: window.jQuery(".rmHoraireInstruction").offset().top},300)
                window.location.hash = "multiple0-A"
            }
        }
        if (this.state.debut !== prevState.debut || this.state.fin !== prevState.fin) {
            let debut =this.state.debut
            let fin =this.state.fin
            this.setState({
                activites: null
            })

            window.jQuery.ajax({
                dataType: 'json',
                url: this.props.constants.ajaxurl,
                method: 'POST',
                crossDomain: true,
                data: {
                    plateaux: this.props.constants.plateaux,
                    action: 'schedulePublicGetActivities',
                    from: debut/1000,
                    to: fin/1000
                },
                success: (response) => {
                    response.forEach(i=>{
                        i.debut = parseInt(i.debut)
                        i.fin = parseInt(i.fin)
                        i.plateau_ID = parseInt(i.plateau_ID)
                    })
                    this.setState({
                        activites: response
                    })
                    this.props.parent.setState({
                        activites: response
                    })
                }
            });
        }
        if (
            this.state.heureDebut !== prevState.heureDebut ||
            this.state.heureFin !== prevState.heureFin ||
            this.state.duree !== prevState.duree ||
            this.state.activites !== prevState.activites ||
            this.state.filtre !== prevState.filtre ||
            this.state.jour_dim !== prevState.jour_dim ||
            this.state.jour_lun !== prevState.jour_lun ||
            this.state.jour_mar !== prevState.jour_mar ||
            this.state.jour_mer !== prevState.jour_mer ||
            this.state.jour_jeu !== prevState.jour_jeu ||
            this.state.jour_ven !== prevState.jour_ven ||
            this.state.jour_sam !== prevState.jour_sam
        ) {
            this.setState({
                dispos: this.getAllPlages()
            })
            this.props.parent.setState({
                dispos: this.getAllPlages()
            })
        }
    }
    handleDateDebut = (d) => {
        this.setState({
            debut: d
        });
    }
    handleDateFin = (d) => {
        this.setState({
            fin: d
        });
    }
    handleNBsemaines = (e) => {
        if (this.state.debut) {
            let fin = this.state.debut+((parseInt(e.target.value)*7 - 1)*24*60*60*1000)
            if (fin < this.state.fin) fin = this.state.fin
            this.setState({
                fin: fin
            });
        }
        this.handleInputChange(e)
    }



    calculateWeek = (d,f) => {
        let jours = (f-d)/(1000*24*60*60)
        if (jours==0) return;
        jours += 1;
        let semaines =  Math.ceil((jours/7))
        return (semaines>=2) ? String(semaines)+" "+this.constants.semaines+"" : String(semaines)+" "+this.constants.semaine;
    }
    getAllPlages = () => {
        if (this.state.heureDebut && this.state.heureFin && this.state.duree && this.state.activites) {
            // S'il n'y a pas de

            let plateaux =this.constants.plateaux;

            let heureDebut = this.state.heureDebut.split(":");
            heureDebut = parseInt(heureDebut[0])+ (parseInt(heureDebut[1])/60);

            let heureFin = this.state.heureFin.split(":");
            heureFin = parseInt(heureFin[0])+ (parseInt(heureFin[1])/60);


            if (heureFin < heureDebut) {
                heureFin = heureFin + 24
            } 

            let duree = this.state.duree.split(":");
            duree = parseInt(duree[0])+ (parseInt(duree[1])/60);

            let plages = [];
            let options = [];

            if (heureFin >= duree+heureDebut) {
                for(let i=heureDebut;i+duree <= heureFin;i=i+0.5) {
                    for (let j=0; j < 7; j++) {
                        if (this.state.filtre == "all" || parseInt(this.state.filtre)==j) {
                            plages.push({ jour: j, debut: i, fin: i+duree });
                        }
                    }
                }

                plages = plages.filter(i => {
                    let attrs = ['jour_jeu','jour_ven','jour_sam','jour_dim','jour_lun','jour_mar','jour_mer']
                    return this.state[attrs[i.jour]]
                });

                plages.sort((a,b)=>{
                    if (a.jour-b.jour !==0) return a.jour-b.jour;
                    return a.debut-b.debut
                })

                let semaineDebut = this.state.debut-(this.state.debut%(1000*60*60*24*7));
                let semaineFin = this.state.fin-(this.state.fin%(1000*60*60*24*7));
                plages = plages.forEach((i)=>{
                    let sousplages = []
                    for (let s=semaineDebut; s<=semaineFin; s=s+1000*60*60*24*7) {
                        if (this.state.debut <=  s+(i.debut*1000*60*60)+i.jour*1000*60*60*24 && this.state.fin >= s+(i.fin*1000*60*60)+i.jour*1000*60*60*24) {
                            sousplages.push({
                                debut: s+(i.debut*1000*60*60)+i.jour*1000*60*60*24,
                                fin: s+(i.fin*1000*60*60)+i.jour*1000*60*60*24
                            })

                        }
                    }
                    sousplages.map(i=>{
                        let debut = i.debut/1000;
                        let fin = i.fin/1000;

                        i.plateau = {};
                        plateaux.forEach(plateau=> {
                            let conflictingactivite = this.state.activites.filter(i=>(parseInt(i.plateau_ID,10)===plateau)).filter(i=>(
                                (parseInt(i.debut) <= debut && debut < parseInt(i.fin)) ||
                                (parseInt(i.debut) < fin && fin <= parseInt(i.fin)) ||
                                (debut <= parseInt(i.debut) && parseInt(i.debut) < fin) ||
                                (debut < parseInt(i.fin) && parseInt(i.fin) <= fin)
                            ));
                            i.plateau[plateau] = conflictingactivite.length
                        })
                    })

                    plateaux.forEach(p => {
                        
                            if (sousplages[0]) {


                                options.push({
                                    plateau: p,
                                    debut: sousplages[0].debut,
                                    fin: sousplages[0].fin,
                                    plage: sousplages,
                                    qte: sousplages.filter(plage=>{
                                        return (plage.plateau[p]==0)
                                    }).length
                                })
                            }
                    })

                })


            }

            options.sort(function(a, b){
                if (a.debut == b.debut) return  a.plateau - b.plateau
                if (moment.utc(a.debut).day() == moment.utc(b.debut).day()) return  a.debut - b.debut
                return moment.utc(a.debut).day() - moment.utc(b.debut).day()}
            );

            return options;

        }
        return [];
    }
    handleInputAll = (e) => {
        if (e.target.checked) {
            this.setState({
                jour_lun: "1",
                jour_mar: "1",
                jour_mer: "1",
                jour_jeu: "1",
                jour_ven: "1",
                jour_sam: "1",
                jour_dim: "1",
            })
        } else {
            this.setState({
                jour_lun: false,
                jour_mar: false,
                jour_mer: false,
                jour_jeu: false,
                jour_ven: false,
                jour_sam: false,
                jour_dim: false,
            })
        }
    }
    render() {

        moment.locale(this.props.constants.locale)
        return (
            <div>
                <div className="fieldLine">
                    <div className="label" style={{ flexBasis: "50%" }}>
                        <label>{this.props.constants.dureeRequise}</label>
                        <select  name="duree" value={this.state.duree} onChange={this.handleInputChange}>
                            {!this.state.duree && <option value=""></option>}
                            {this.time.map(i=>
                                <option key={i} value={i}>{i}</option>
                            )}
                        </select>
                    </div>



                    <div className="label" style={{ flexBasis: "50%" }}>
                        <label>Jours{this.props.constants.jours}</label>
                        <div className="field">
                            <div className="labelDate">
                                <label>Tous</label>
                                <input onChange={this.handleInputAll} type="checkbox" name="jour_all" checked={(this.state.jour_lun == "1" && this.state.jour_mar == "1" && this.state.jour_mer == "1" && this.state.jour_jeu == "1" && this.state.jour_ven == "1" && this.state.jour_sam == "1" && this.state.jour_dim == "1") ? true : false} />
                            </div>
                            <div className="labelDate">
                                <label>D</label>
                                <input type="checkbox" name="jour_dim" checked={(this.state.jour_dim == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>L</label>
                                <input type="checkbox" name="jour_lun" checked={(this.state.jour_lun == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>M</label>
                                <input type="checkbox" name="jour_mar" checked={(this.state.jour_mar == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>M</label>
                                <input type="checkbox" name="jour_mer" checked={(this.state.jour_mer == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>J</label>
                                <input type="checkbox" name="jour_jeu" checked={(this.state.jour_jeu == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>V</label>
                                <input type="checkbox" name="jour_ven" checked={(this.state.jour_ven == "1")} onChange={this.handleInputChange} />
                            </div>
                            <div className="labelDate">
                                <label>S</label>
                                <input type="checkbox" name="jour_sam" checked={(this.state.jour_sam == "1")} onChange={this.handleInputChange} />
                            </div>
                        </div>
                    </div>





                 
                </div>


                <div className="fieldLine">
                    <div className="label" style={{ flexBasis: "50%" }}>
                        <label>{this.props.constants.du}</label>
                        <DateInput
                            value={this.state.debut}
                            maxDate={this.constants.options.moisMax*1000}
                            minDate={Date.now()+(this.constants.options.delay*1000*24*60*60)}
                            format="yy-mm-dd"

                            onChange={this.handleDateDebut} />
                    </div>
                    <div className="label"  style={{ flexBasis: "50%" }}>
                        <label>{this.props.constants.au}</label>
                        <DateInput
                            value={this.state.fin}
                            minDate={((Date.now()+(this.constants.options.delay*1000*24*60*60)) < this.state.debut) ?  this.state.debut : Date.now()+(this.constants.delay*1000*24*60*60)}
                            maxDate={this.constants.options.moisMax*1000}
                            format="yy-mm-dd"

                            onChange={this.handleDateFin} />
                    </div>
                   
                </div>

<p>{this.props.constants.instructionPlages}</p>
                <div className="fieldLine">
                    <div className="label" style={{ flexBasis: "50%" }}>
                        <label>{this.props.constants.heureDebut}</label>

                        <select name="heureDebut" value={this.state.heureDebut} onChange={this.handleInputChange}>
                            {!this.state.heureDebut && <option value=""></option>}
                            {this.semaines.map(i=>
                                <option key={i} value={i}>{i}</option>
                            )}
                        </select>

                    </div>
                    <div className="label" style={{ flexBasis: "50%" }}>
                        <label>{this.props.constants.heureFin}</label>
                        <select name="heureFin" value={this.state.heureFin} onChange={this.handleInputChange}>
                            {!this.state.heureFin && <option value=""></option>}
                            {this.semaines.filter(i => {
                                if (this.string2temps(i) > this.string2temps(this.state.heureDebut) && this.string2temps(i) < this.string2temps(this.state.heureDebut)+this.string2temps(this.state.duree) ) return false
                                return true;
                            }).sort((a,b)=> {
                                if (this.string2temps(a) > this.string2temps(this.state.heureDebut) && this.string2temps(b) > this.string2temps(this.state.heureDebut)) {
                                    if (this.string2temps(a) > this.string2temps(b)) return 1;
                                return -1;  
                                }
                                if (this.string2temps(a) > this.string2temps(this.state.heureDebut)) {
                                    return -1;
                                }

                                if (this.string2temps(b) > this.string2temps(this.state.heureDebut)) {
                                    return 1;
                                }
                                if (this.string2temps(a) > this.string2temps(b)) return 1;
                                return -1;  

                            }).splice(0,32).map(i=>
                                <option key={i} value={i}>{i} { this.string2temps(i) < this.string2temps(this.state.heureDebut) && " le lendemain" }</option>
                            )}
                        </select>

                    </div>
                </div>
                { this.state.heureDebut && this.state.heureFin && this.state.duree && this.state.activites  &&
                    <div>

{ (this.state.jour_dim || this.state.jour_lun || this.state.jour_mar || this.state.jour_mer || this.state.jour_jeu || this.state.jour_ven || this.state.jour_sam) &&
<React.Fragment>
                        <p className="rmHoraireInstruction">{this.constants.rmHoraireInstruction}</p>
                        <div className="ReservationMultiplesTitre">
                            <h3>{this.constants.disponibiliteJour}</h3>

                        </div>
                        <table className="ReservationMultiplesOptions">
                            <thead>
                                <tr>
                                    <th>{this.constants.jour}</th>
                                    <th>{this.constants.plageHoraire}</th>

                                    <th>{this.constants.plateau}</th>
                                    <th>{this.constants.semainesDispos}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.dispos.filter(t => {
                                    let totalSemaines = Math.floor(this.state.fin - this.state.debut)/(1000*60*60*24*7)
                                    if (t.qte < totalSemaines - this.constants.options.chercherPlus) return false;
                                    return true;
                                }).filter(i => (i.qte)).map((i,index)=>
                                    {
                                        return(
                                            <tr key={index} className={

                                                    (i.checked) ? 'selectionne' : 'disponible'
                                                }>
                                                <td>{moment.utc(i.debut).format('dddd')}</td>
                                                <td>{moment.utc(i.debut).format('HH:mm')}/{moment.utc(i.fin).format('HH:mm')}</td>
                                                <td>{window.plateaux.filter(p=>(i.plateau==parseInt(p.ID))).map(j=>j.name)}</td>
                                                <td>{i.qte}</td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={i.checked}
                                                        onChange={(e)=>{

                                                            i.checked = (e.target.checked)
                                                            let newState = [].concat(this.state.dispos.map(i => Object.assign({},i)))
                                                            this.setState({
                                                                dispos: newState
                                                            })
                                                            this.handleInputChange(e)
                                                            this.props.parent.setState({
                                                                selected: newState.filter(i => i.checked),
                                                            })



                                                        }}
                                                        />
                                                </td> 
                                            </tr>
                                        )
                                    }
                                )}
                                {this.state.dispos.filter(t => {
                                    let totalSemaines = Math.floor(this.state.fin - this.state.debut)/(1000*60*60*24*7)
                                    if (t.qte < totalSemaines - this.constants.options.chercherPlus) return false;
                                    return true;
                                }).filter(i => (i.qte)).length == 0 &&
                                    <tr>
                                        <td colSpan="6" className="noResults">{this.constants.noResults} <br /> {this.constants.noresults2}</td>
                                    </tr>


                                }

                            </tbody>
                        </table>
                        </React.Fragment>
                         || <p style={{ color: "red" }}>{this.constants.choixJour}</p> }
                    </div>
                }
            </div>
        )
    }
}
export default ReservationMultiplesDispo;



// WEBPACK FOOTER //
// ./src/ReservationMultiples1.js